<template>
	<section class="hero is-fullheight">
		<div class="hero-body">
			<div>
				<Logo class="big-logo"/>
				<h2 class="subtitle has-text-white">
					<p>Les quelques étapes qui vont suivre vont vous permettre de consulter toutes les offres de nos magazines.</p>
				</h2>
				<div class="buttons">
					<router-link to="choix-titre" class="button is-warning is-outlined">Commencer</router-link>      
				</div>
			</div>
		</div>
	</section>
</template>
<script>
	export default {
		name: 'Accueil',
		metaInfo() {
			return this.setMeta({
				title : `Les offres SO PRESS`, 
				description : `Abonnez-vous à un magazine du groupe SO PRESS (SO FOOT, Society, SO FOOT Club, L'étiquette, etc.) Il y a forcément une offre d'abonnement pour vous`,
				image : location.protocol + '//' + location.host+'/sopress.jpg'
			})	
		}
	}
</script>
<style>
</style>